module.exports = __webpack_public_path__ + "img/project-langsbay.a59894cc.png";